var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58.33 46.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.52,7.62H3.81C1.71,7.62,0,5.91,0,3.81H0C0,1.71,1.71,0,3.81,0H54.52c2.1,0,3.81,1.71,3.81,3.81h0c0,2.1-1.71,3.81-3.81,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.52,20.7H3.81c-2.1,0-3.81-1.71-3.81-3.81H0c0-2.1,1.71-3.81,3.81-3.81H54.52c2.1,0,3.81,1.71,3.81,3.81h0c0,2.1-1.71,3.81-3.81,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.52,33.79H3.81c-2.1,0-3.81-1.71-3.81-3.81H0c0-2.1,1.71-3.81,3.81-3.81H54.52c2.1,0,3.81,1.71,3.81,3.81h0c0,2.1-1.71,3.81-3.81,3.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.52,46.87H3.81c-2.1,0-3.81-1.71-3.81-3.81H0c0-2.1,1.71-3.81,3.81-3.81H54.52c2.1,0,3.81,1.71,3.81,3.81h0c0,2.1-1.71,3.81-3.81,3.81Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu1);
export default __webpack_public_path__ + "static/media/Menu1.f4c10669c28349aa0fd742bb2132dd1e.svg";
export { ForwardRef as ReactComponent };